<template>
  <v-dialog
      v-model="dialog"
      width="1200px"
      small
      persistent
  >
    <v-card>
      <v-card-title>
        {{ processType === 'new' ? 'Tahsilat Oluştur' : 'Tahsilat Düzenle' }}
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container--fluid">
          <div class="row">
            <div class="col-lg-6">
              <search-select
                  :search-type="'current'"
                  @itemChange="(e) => (selectedCurrent = e)"
                  :label="'Cari'"
              >
              </search-select>
            </div>
            <div class="col-lg-6">
              <v-menu
                  transition="scale-transition"
                  offset-y
                  :close-on-content-click="false"
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="formattedDate(date)"
                      label="Tarih"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      filled
                      solo
                      dense
                      clearable
                      @click:clear="date = null"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    locale="tr"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col-lg-6">
              <v-select
                  v-model="type"
                  label="Tip"
                  filled
                  solo
                  dense
                  :items="[
                      {value: 2, text: 'Kredi Kartı'},
                      {value: 1, text: 'Nakit'}

                  ]"
                  item-value="value"
                  item-text="text">
              </v-select>
            </div>
            <div class="col-lg-4">
              <v-text-field
                  v-model="amount"
                  filled
                  solo
                  dense
                  label="Tutar"
                  :suffix="suffixes()"
              >
              </v-text-field>
            </div>
            <div class="col-lg-2">
              <v-select
                  v-model="currency"
                  label="Birim"
                  filled
                  solo
                  dense
                  :items="[
                     {value: 0, text: '₺'},
                     {value: erpSettings.netsisUsdCode, text: '$'},
                     {value: erpSettings.netsisEuroCode, text: '€'},
                     {value: erpSettings.netsisGbpCode, text: '£'},
                  ]"
                  item-value="value"
                  item-text="text">
              </v-select>
            </div>
            <div class="col-lg-12">
              <h5 class="text-primary">Açıklama</h5>
              <v-textarea
                  v-model="description"
                  filled
                  dense
                  solo
                  rows="3"
              ></v-textarea>
            </div>

          </div>
        </div>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small class="me-1" color="secondary" @click="dialog = false">İptal Et</v-btn>
          <v-btn small color="success" @click="saveCollection">Tahsilatı Kaydet</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>

import {validationMixin} from "vuelidate";
import {formattedDate} from "@/momentHelper";
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../helpers";
import SearchSelect from "@/components/searchSelect.vue";

// import {required} from "vuelidate/lib/validators";

export default {
  components: {SearchSelect},
  mixins: [validationMixin],

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    processType: {
      type: String,
      default: "new",
    },
    collectionId: {
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapState("company", ['branchList']),
    ...mapState("auth", ["user"]),
    ...mapState("current", ["salesPersonList"]),
    ...mapState("collactions", ["physicalCollectionList", "physicalCollectionListHeaders", "physicalCollectionListLoading"]),
    ...mapState("settings", ["erpSettings"]),
  },
  data() {
    return {
      dialog: false,
      date: null,
      selectedCurrent: null,
      description: null,
      amount: null,
      type: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      currency: 0,
    }
  },
  methods: {
    ...mapActions("current", ["fetchSingleCurrent"]),
    ...mapActions("current", ["fetchCurrentList"]),
    ...mapActions("collactions", ["fetchSingleCollection", "collectionAdd", "collectionUpdate"]),
    formattedDate,
    numberConverter,
    close() {
      this.$emit("dialogChange", 'anan');
    },
    suffixes() {
      if (this.erpSettings.netsisGbpCode === this.currency) {
        return "GBP"
      } else if (this.erpSettings.netsisEuroCode === this.currency) {
        return "EUR"
      } else if (this.erpSettings.netsisUsdCode === this.currency) {
        return "USD"
      } else if (0 === this.currency) {
        return "TRY"
      }
    },
    async searchCurrentList() {
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(this.currentSearchText == "" || this.currentSearchText == null ? false : true) && {searchText: this.currentSearchText}
        },
        body: {},
        onlyData: true,
        loading: false
      });
      this.searchCurrentLoading = false
    },
    async saveCollection() {
      if (this.processType === 'new') {

        await this._collectionAdd();

      } else {

        await this._collectionUpdate()

      }
    },
    async _collectionUpdate() {
      await this.collectionUpdate({
        params: {
          userId: this.user.UserId
        },
        body: {
          Id: this.collectionId,
          Type: this.type,
          Date: this.date,
          CurrentCode: this.selectedCurrent,
          Description: this.description,
          Amount: this.amount.replace(/\./g, '').replace(/,/, '.'),
        },
      });
      this.$parent._fetchAllCollections();
      this.dialog = false
    },
    async _collectionAdd() {
      await this.collectionAdd({
        params: {
          userId: this.user.UserId
        },
        body: {
          Type: this.type,
          Date: this.date,
          CurrentCode: this.selectedCurrent,
          Description: this.description,
          Amount: this.amount.replace(/\./g, '').replace(/,/, '.'),
        },
      });
      this.$parent._fetchAllCollections();
      this.dialog = false
    },
    async _fetchCollectionSingle() {
      let collectionSingleResult = await this.fetchSingleCollection({
        params: {},
        body: {},
        urlSegments: [this.collectionId]
      });
      if (collectionSingleResult) {
        this.type = collectionSingleResult.data.data.type;
        this.date = collectionSingleResult.data.data.date;
        this.description = collectionSingleResult.data.data.description;
        this.amount = numberConverter(collectionSingleResult.data.data.amount);
        this.selectedCurrent = await this.fetchSingleCurrent({
          params: {
            currentCode: collectionSingleResult.data.data.currentCode
          },
        });
      } else {
        this.type = null;
        this.date = null;
        this.selectedCurrent = null;
        this.description = null;
        this.amount = null;
      }
    },
  },
  // validations() {
  //   return {
  //     startDate: {required},
  //     valueKey1: {required},
  //     currentType: {required},
  //     stockType: {required},
  //   };
  // },

  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
      if (newVal) {
        newVal;
      }
    },
    "showDialog": function (newVal) {
      this.dialog = newVal
      if (newVal) {
        if (this.processType === 'new') {
          this.type = null;
          this.date = null;
          this.selectedCurrent = null;
          this.description = null;
          this.amount = null;
        } else if (this.processType === 'edit') {
          this._fetchCollectionSingle()
        }
      }
    },
    currentSearchText: function (newVal) {
      if (newVal && (newVal.length > 2)) {
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {

          this.searchCurrentList();
        }, 3000);
      } else {
        this.searchCurrentLoading = false;
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
      }
    },
  }
}
</script>


<style scoped>

</style>